/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion, Card, Button } from 'react-bootstrap';
import * as actions from '../../store/SupplierSuggestion.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as careLabelAction from '../../../DevlopmentOrder/CareLabels/store/CARELABEL.action';
import DuplicateDeleteModal from '../../../../Components/ModalPopup/DuplicateDeleteModal';
import CareInstructionDetail from './CareInstructionTable/CareInstructionDetail';

function CareLabelCard({
  careLibaries,
  devOrderId,
  approveReject,
  sugestionObj,
  suggestionType,
  updateData,
  updatedSuggestionLibrary,
  approveRejectDisable,
  autoApproved,
}) {
  const dispatch = useDispatch();
  const careLabelReducer = useSelector((reducerstate) => reducerstate);
  const { UserDetails, SupplierSuggestion } = careLabelReducer;
  const { userInfo } = UserDetails;
  const { duplicateCodeModal } = SupplierSuggestion;
  const [oldSuggestion, setOldSuggestion] = useState([]);
  const [selectedIdSymbol, setSelectedIdSymbol] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [approveRejectComment, setApproveRejectComment] = useState();
  const [careSymbolAsOriginal, setCareSymbolAsOriginal] = useState([]);
  const [careTabsData, setCareTabsData] = useState([]);
  const [oldDataFound, setOldDataFound] = useState(suggestionType === 'new');

  useEffect(() => {
    if (careLibaries?.tabs?.length > 0) {
      const tabs = careLibaries?.tabs?.map((tab) => {
        return {
          ...tab,
          selectAll: false,
          selectedIds: [],
        };
      });
      setCareTabsData(tabs);
    }
  }, [careLibaries?.tabs]);

  const hasPendingStatus = (tabDetails, rowId) => {
    if (!tabDetails?.length) return false;
    const rowItems = tabDetails.filter((detail) => detail.rowId === rowId);
    return rowItems.some((item) => !['Approved', 'Deleted'].includes(item.status));
  };

  const pendingActionSymbol = careSymbolAsOriginal?.reduce((acc, tab) => {
    if (tab?.tabDetails?.length > 0) {
      // Get unique rowIds from this tab
      const uniqueRowIds = [...new Set(tab.tabDetails.map((detail) => detail.rowId))];

      // For each unique rowId, check if it has any pending status
      uniqueRowIds.forEach((rowId) => {
        if (hasPendingStatus(tab.tabDetails, rowId)) {
          // Get all details for this rowId
          const rowDetails = tab.tabDetails.filter((detail) => detail.rowId === rowId);
          acc.push(...rowDetails);
        }
      });
    }
    return acc;
  }, []);

  const pendingActionSymbolCount = Array.isArray(pendingActionSymbol) && pendingActionSymbol.length;

  useEffect(() => {
    // Check if any tab has selectedIds with length > 0
    const hasSelectedItems = careTabsData?.some((tab) => tab?.selectedIds && tab.selectedIds.length > 0);

    // Enable/disable approve reject button based on selection
    if (hasSelectedItems) {
      approveRejectDisable(false); // Enable button
    } else {
      approveRejectDisable(true); // Disable button
    }
  }, [careTabsData]);

  const { t } = useTranslation('common');

  useEffect(() => {
    if (suggestionType !== 'new') {
      getOldCareLabelDetail();
    }
  }, []);

  useEffect(() => {
    if (oldDataFound && careTabsData?.length > 0) {
      const newCareSymbol = careTabsData?.map((tab) => {
        // Find matching tab in oldDataArr
        const matchingTab = oldSuggestion?.length > 0 && oldSuggestion?.find((oldTab) => oldTab?.tabId === tab?.tabId);
        // If no matching tab found or tab details don't exist in oldDataArr, mark for deletion
        if (!matchingTab) {
          return tab;
        }
        let updatedTabDetails = [];
        if (tab.tabDetails.length > 0) {
          // Check if all tabDetails in current tab exist in matching oldDataArr tab
          updatedTabDetails = tab?.tabDetails?.map((detail) => {
            const matchingDetail = matchingTab?.tabDetails?.some((oldDetail) => oldDetail?.rowId === detail?.rowId);
            return {
              ...detail,
              status: matchingDetail ? detail.status : 'Deleted',
            };
          });
        }
        return {
          ...tab,
          tabDetails: updatedTabDetails,
        };
      });
      setCareTabsData(newCareSymbol);
      setCareSymbolAsOriginal(newCareSymbol);
    }
  }, [oldSuggestion, oldDataFound]);

  useEffect(() => {
    if (oldSuggestion?.length > 0) {
      updatedSuggestionLibrary(careSymbolAsOriginal);
    } else {
      updatedSuggestionLibrary(careTabsData);
    }
  }, [careSymbolAsOriginal, oldSuggestion, careTabsData]);

  const getOldCareLabelDetail = async () => {
    const [{ _id }] = devOrderId;

    const careData = await dispatch(careLabelAction.fetchCareInstructionProduct({ devOrderId: _id }));
    if (careData?.tabs?.length > 0) {
      setOldSuggestion(careData?.tabs);
      setOldDataFound(!oldDataFound);
    }
  };

  useEffect(() => {
    setShowConfirmationPopup(approveReject?.status);
    setConfirmAction(approveReject?.action);
  }, [approveReject]);

  const onSelectCheckBoxSymbol = async (selectedIds, rowId, uniqueRow, tabId) => {
    let selectedItems = [...selectedIds];

    if (selectedItems?.includes(rowId)) {
      selectedItems = selectedItems?.filter((id) => id !== rowId);
    } else {
      selectedItems?.push(rowId);
    }
    const allRowsSelected = selectedItems?.length === uniqueRow?.length;
    const newTabs = careTabsData?.map((tab) => {
      if (tab?.tabId === tabId) {
        return {
          ...tab,
          selectedIds: selectedItems,
          selectAll: allRowsSelected,
        };
      }
      return tab;
    });
    setCareTabsData(newTabs);
  };

  const autoCheckedSymbol = (id) => {
    setSelectedIdSymbol([
      {
        type: 'symbol',
        _id: id,
      },
    ]);
  };

  const handleSelectAllSymbol = (e, tabDetails, tabId) => {
    const newTabs = careTabsData?.map((tab) => {
      if (tab?.tabId === tabId) {
        return {
          ...tab,
          selectedIds: e.target.checked ? [...new Set(tabDetails?.map((arr) => arr?.rowId))] : [],
          selectAll: e.target.checked,
        };
      }
      return tab;
    });
    setCareTabsData(newTabs);
  };

  const confirmApproveReject = async () => {
    sugestionObj.comment = approveRejectComment;
    sugestionObj.componentId =
      careTabsData?.length > 0 &&
      careTabsData
        ?.map((tab) => tab?.selectedIds?.length > 0 && tab?.selectedIds)
        .filter(Boolean)
        .flat();
    if (confirmAction === 'Approved') {
      sugestionObj.type = suggestionType;
    }

    const response = await dispatch(actions.approveRejectSuggestion(confirmAction, sugestionObj, t));

    if (response) {
      setShowConfirmationPopup(false);
      updateData();
    }
  };

  const handleCommentChange = (e) => {
    setApproveRejectComment(e.target.value);
  };
  const closeDuplicateDeleteModal = () => {
    dispatch(actions.setDuplicateCodeModal(false, null));
  };

  return (
    <div className="supplier-add supplier-detail">
      <div className="collapse-card">
        {careTabsData?.length > 0 &&
          careTabsData?.map((item) => {
            return (
              item?.tabDetails?.length > 0 && (
                <Accordion className="common-accordion" key={item?.tabId} defaultActiveKey="0">
                  <Card className="overflow-visible">
                    <Card.Header>
                      {item?.tabName}
                      <Accordion.Toggle className="btn-toggle" as={Button} variant="link" eventKey="0">
                        <i className="icon-Add" />
                      </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                        <CareInstructionDetail
                          pendingActionSymbolCount={pendingActionSymbolCount}
                          careSymbol={careSymbolAsOriginal}
                          ele={item}
                          oldSuggestion={oldSuggestion}
                          suggestionType={suggestionType}
                          selectedIdSymbol={selectedIdSymbol}
                          handleSelectAllSymbol={handleSelectAllSymbol}
                          onSelectCheckBoxSymbol={onSelectCheckBoxSymbol}
                          autoCheckedSymbol={autoCheckedSymbol}
                          role={userInfo.role}
                          autoApproved={autoApproved}
                          // defaultChecked={uniqueRow.length === 1}
                        />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              )
            );
          })}
      </div>

      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={confirmApproveReject}
          comment={approveRejectComment}
          loading={false}
          title={confirmAction === 'Approved' ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_APPROVE') : t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_REJECT')}
          message={
            confirmAction === 'Approved' ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_APPROVE') : t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_REJECT')
          }
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
          isCommentOn
          commentText={handleCommentChange}
        />
      )}
      {duplicateCodeModal.isOpen && (
        <DuplicateDeleteModal
          onOpen={duplicateCodeModal.isOpen}
          title={t('CARE_LABEL_CARD.ERROR_LOG')}
          toggle={() => closeDuplicateDeleteModal()}
          codeItem={duplicateCodeModal?.code}
        />
      )}
    </div>
  );
}

export default CareLabelCard;
